/* app/js/src/components/user/common/user-form/user-form.component.scss */
.cursor-pointer {
  cursor: pointer;
}
.user-form {
  background-color: white;
  max-height: 80dvh;
  display: block;
  overflow-y: auto;
  padding-top: 14px;
}
.action-buttons {
  height: 40px;
  text-align: right;
}
.action-buttons ichannel-button {
  margin-left: 20px;
}
.tabs-menu > div {
  display: inline-block;
  vertical-align: middle;
  line-height: 60px;
  color: #232f3a;
  width: 33.3333333333%;
  text-align: center;
  background-color: #e3e6ea;
  cursor: pointer;
  font-weight: bold;
}
.tabs-menu > div:hover {
  background-color: #cecece;
}
.tabs-menu > div.selected {
  background-color: white;
}
/*# sourceMappingURL=user-form.component.css.map */
